/** What a shareable link of an issue points at. */
export enum ShareableUrlTargetKind {
  issueDocument = 'issueDocument',
  eventDocument = 'eventDocument',
  incomingEmailDocument = 'incomingEmailDocument',
  linkedDocumentation = 'linkedDocumentation',
}

export type ShareableUrlTarget =
  | { kind: ShareableUrlTargetKind.issueDocument; issueId: string; documentId: string }
  | { kind: ShareableUrlTargetKind.eventDocument; issueId: string; eventId: string; documentId: string }
  | {
      kind: ShareableUrlTargetKind.incomingEmailDocument;
      issueId: string;
      incomingEmailMessageId: string;
      documentId: string;
    }
  | { kind: ShareableUrlTargetKind.linkedDocumentation; issueId: string; linkedDocumentationId: string };

/** The project API path of the target's shareable link. */
export function shareableUrlPathOf(target: ShareableUrlTarget): string {
  switch (target.kind) {
    case ShareableUrlTargetKind.issueDocument:
      return `issue/${target.issueId}/document/${target.documentId}/shareableUrl`;
    case ShareableUrlTargetKind.eventDocument:
      return `issue/${target.issueId}/event/${target.eventId}/document/${target.documentId}/shareableUrl`;
    case ShareableUrlTargetKind.incomingEmailDocument:
      return `issue/${target.issueId}/incomingEmailMessage/${target.incomingEmailMessageId}/document/${target.documentId}/shareableUrl`;
    case ShareableUrlTargetKind.linkedDocumentation:
      return `issue/${target.issueId}/documentation/${target.linkedDocumentationId}/shareableUrl`;
  }
}
